let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("3tr0N")).then(() => parcelRequire('68YeM'));